export enum PaymentMethod {
    STRIPE = "Stripe",
    COD = "cod",
    CARD = "card"
}